import { cloneDeep } from "lodash";
import { fetch, key, trans } from "./utils";
import FeatureDetails from "../components/featureDetails/featureDetails";
import { GeoJSON, WKT } from "ol/format";
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import { getProjectionCode } from "./utils";
import {
  Circle as CircleStyle,
  Fill,
  RegularShape,
  Stroke,
  Style,
  Text,
} from "ol/style.js";

function isValidDate(date) {
  return (
    date &&
    Object.prototype.toString.call(date) === "[object Date]" &&
    !isNaN(date)
  );
}

export function WKTtoFeature(wkt, dataProjection, featureProjection) {
  const format = new WKT();

  const options =
    dataProjection && featureProjection
      ? {
          dataProjection: dataProjection,
          featureProjection: featureProjection,
        }
      : null;

  const feature = format.readFeature(wkt, options);

  return feature;
}

export function WKTtoGeoJSON(wkt, dataProjection, featureProjection) {
  const feature = WKTtoFeature(wkt, dataProjection, featureProjection);

  const geoJSON = new GeoJSON().writeFeature(feature);

  return JSON.parse(cloneDeep(geoJSON));
}

export function FeatureToGeoJSON(feature) {
  let geoJSON = {};

  if (Array.isArray(feature)) {
    geoJSON = new GeoJSON().writeFeatures(feature);
  } else {
    geoJSON = new GeoJSON().writeFeature(feature);
  }

  return JSON.parse(cloneDeep(geoJSON));
}

export function GeoJSONToWKT(geoJSON, fromProjection, toProjection) {
  const json = new GeoJSON({
    dataProjection: fromProjection,
    featureProjection: toProjection,
  }).readFeature(geoJSON);

  const wkt = new WKT().writeFeature(json);
  return wkt;
}

export function showFeatureDetails(feature) {
  if (feature.url) {
    fetch(
      window["appConfig"]()["api"](
        "?proxy=getfeatures&method=get&url=".concat(feature.url)
      ),
      "POST",
      {},
      [],
      (resp) => {
        let respFeature = resp.data.features[0];
        respFeature.projection = getProjectionCode(feature.projection);
        respFeature.layerId = feature.layerId;

        window["primaryModal"].setState({
          show: true,
          title: trans("Feature details"),
          size: "xl",
          body: <FeatureDetails feature={respFeature}></FeatureDetails>,
        });
      }
    );
  } else {
    window["primaryModal"].setState({
      show: true,
      title: trans("Feature details"),
      size: "xl",
      body: <FeatureDetails feature={feature}></FeatureDetails>,
    });
  }
}

export function showFeature(feature, type, maxZoom) {
  const editStyle = new Style({
    fill: new Fill({
      color: "rgba(255, 191, 40, 0.8)",
    }),
    stroke: new Stroke({
      color: "rgba(0, 0, 0, 1)",
      lineDash: [10, 10],
      width: 2,
    }),
    image: new CircleStyle({
      radius: 8,
      stroke: new Stroke({
        color: "rgba(0, 0, 0, 1)",

        width: 2,
      }),
      fill: new Fill({
        color: "rgba(196, 0, 0, 0.8)",
      }),
    }),
  });

  if (feature.url) {
    fetch(
      window["appConfig"]()["api"](
        "?proxy=getfeatures&method=get&url=".concat(feature.url)
      ),
      "POST",
      {},
      [],
      (resp) => {
        let respFeature = resp.data;

        const json = new GeoJSON({
          dataProjection: getProjectionCode(feature.projection),
          featureProjection: window["map"].getView().getProjection().getCode(),
        }).readFeature(respFeature.features[0]);

        const vectorSource = new VectorSource({
          features: [json],
        });

        const vectorLayer = new VectorLayer({
          source: vectorSource,
        });

        window["map"].addLayer(vectorLayer);

        window["map"]
          .getView()
          .fit(vectorSource.getExtent(), { maxZoom: maxZoom ? maxZoom : 18 });

        vectorLayer.setZIndex(7000);

        setTimeout(() => {
          vectorLayer.getSource().removeFeature(json);
        }, 5000);
      }
    );
  } else {
    const json = new GeoJSON({
      dataProjection: getProjectionCode(feature.projection),
      featureProjection: window["map"].getView().getProjection().getCode(),
    }).readFeature(feature);

    const vectorSource = new VectorSource({
      features: [json],
    });

    const vectorLayer = new VectorLayer({
      source: vectorSource,
      style: editStyle,
    });

    window["map"].addLayer(vectorLayer);

    vectorLayer.setZIndex(7000);

    window["map"]
      .getView()
      .fit(vectorSource.getExtent(), { maxZoom: maxZoom ? maxZoom : 18 });

    setTimeout(() => {
      vectorLayer.getSource().removeFeature(json);
    }, 3000);
  }
}

export function copyFeature(feature, store, layerName, layerTitle) {
  if (feature.url) {
    fetch(
      window["appConfig"]()["api"](
        "?proxy=getfeatures&method=get&url=".concat(feature.url)
      ),
      "POST",
      {},
      [],
      (resp) => {
        let respFeature = resp.data;

        const json = new GeoJSON({
          dataProjection: getProjectionCode(feature.projection),
          featureProjection: window["map"].getView().getProjection().getCode(),
        }).readFeature(respFeature.features[0]);

        json.values_ = { geometry: json.values_.geometry };

        store.dispatch({
          type: "edit/addtocopied",
          payload: {
            projection: feature.projection,
            geojson: FeatureToGeoJSON(json),
            layerName: layerName,
            layerTitle: layerTitle,
            feature: json,
            featureId: json.getId(),
            _feature: feature,
          },
        });
      }
    );
  } else {
    const json = new GeoJSON({
      dataProjection: getProjectionCode(feature.projection),
      featureProjection: window["map"].getView().getProjection().getCode(),
    }).readFeature(feature);

    json.values_ = { geometry: json.values_.geometry };

    json.setProperties({});

    store.dispatch({
      type: "edit/addtocopied",
      payload: {
        projection: feature.projection,
        geojson: FeatureToGeoJSON(json),
        layerName: layerName,
        layerTitle: layerTitle,
        feature: json,
        featureId: json.getId(),
        _feature: feature,
      },
    });
  }
}

export function isFavorite(featureId, favoritesStore) {
  let _isFavorite = false;

  favoritesStore?.forEach((feature) => {
    if (feature._featureId === featureId) {
      _isFavorite = true;
    }
  });

  return _isFavorite;
}

export function formatSearchResultsFromServiceResponse(resp, index = 0) {
  let attributes = [];

  if (resp) {
    if (resp.data) {
      if (resp.data[index]) {
        if (resp.data[index]._response) {
          if (resp.data[index]._response._attributes) {
            resp.data[index]._response._attributes.forEach((el) => {
              attributes.push(el[0]);
            });
          }
        }
      }
    }
  }

  return attributes;
}

export function filterFeatureRecordFromAttribute(
  record,
  attribute,
  operator,
  value
) {
  switch (operator) {
    case "is":
      if (record[attribute] === value) {
        return record;
      }
      break;

    case ">":
      if (record[attribute] > value) {
        return record;
      }
      break;

    case ">=":
      if (record[attribute] >= value) {
        return record;
      }
      break;

    case "<":
      if (record[attribute] < value) {
        return record;
      }
      break;

    case "<=":
      if (record[attribute] <= value) {
        return record;
      }
      break;

    case "=":
      if (record[attribute] === value) {
        return record;
      }
      break;

    case "like":
      if (
        record[attribute].toString().toLowerCase().match(value.toLowerCase())
      ) {
        return record;
      }
      break;
  }

  return null;
}

export function filterGeoJSONFromAttribute(
  geoJSON,
  attribute,
  operator,
  value
) {
  let data = getGeoJSONData(geoJSON);

  let filteredData = [];

  data?.forEach((record) => {
    let filteredRecord = filterFeatureRecordFromAttribute(
      record,
      attribute,
      operator,
      value
    );
    if (filteredRecord) {
      filteredData.push(filteredRecord);
    }
  });

  return filteredData;
}

export function getGeoJSONData(geoJSON) {
  let data = [];

  geoJSON?.features.forEach((feature) => {
    if (feature.properties) {
      data.push({ ...feature.properties });
    }
  });

  return [...data];
}

export function getAttributesFromGeoJSON(geoJSON) {
  let attributes = [];

  let geoJSONAttributes = [];

  geoJSON?.features.forEach((feature) => {
    if (feature?.properties) {
      Object.keys(feature.properties)?.forEach((attribute) => {
        if (geoJSONAttributes.indexOf(attribute) < 0) {
          let attrType = isValidDate(feature.properties[attribute])
            ? "date"
            : "string";

          let visible =
            ["_feature", "_featureUrl", "_featureId", "_srsName"].indexOf(
              attribute
            ) < 0
              ? true
              : false;

          geoJSONAttributes.push(attribute);
          attributes.push({
            name: attribute,
            type: attrType,
            title: attribute,
            value: null,
            editor: null,
            sortable: true,
            order: 0,
            visible: visible,
            searchable: true,
            isGeometry: false,
            isVisible: visible,
            showOnSummary: false,
          });
        }
      });
    }
  });

  return attributes;
}

export function addFeatureIdToGeoJSONProperties(geoJSON, projection) {
  let newGeoJSON = { ...geoJSON };

  newGeoJSON?.features.forEach((feature) => {
    if (feature?.properties) {
      let clonedFeature = JSON.stringify(feature);

      let _featureId = key();

      feature.properties["_featureId"] = _featureId.toString();

      feature.properties["_feature"] = clonedFeature;

      feature.properties["_srsName"] = projection;
    }
  });

  return newGeoJSON;
}
